// extracted by mini-css-extract-plugin
export default {"footer":"sidebarFooter_footer__8-7uc"};